import routes from './routes';
import { SetRoutes } from 'components';

const ConsumiNetSalesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default ConsumiNetSalesPages;
